<template>
  <div class="interface">
    <el-container>
      <el-aside>
        <div class="menu">
          <el-menu class="el-menu-vertical-demo" :default-active="activeIndex">
            <div v-for="(item, index) in menuData" :key="index">
              <div v-if="item.children == undefined">
                <el-menu-item :index="item.type" @click="getFile(item)">{{
                  item.name
                }}</el-menu-item>
              </div>
              <subMenu
                v-else
                :data="item"
                :itemClick="getFile"
                :key="item.type"
              ></subMenu>
            </div>
          </el-menu>
        </div>
      </el-aside>
      <el-main id="imain">
        <div class="main">
          <div class="breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item
                v-for="(item, index) in breadcrumbData"
                :key="index"
                >{{ item }}</el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
          <div class="filename">{{ fileName }}</div>
          <div class="updateTime">
            <!-- {{ $t("lang.updateTime") }}：2021-05-29 14:16:00 -->
          </div>
          <div class="divider"></div>
          <div class="content">
            <MarkdownIt
              class="md-body"
              :content="content"
              :options="options"
            ></MarkdownIt>
            <el-divider id="markdown-body-bottom-divider"></el-divider>
            <div class="guide" id="markdown-body-bottom-guide">
              <div class="left">
                <div class="text" v-if="previous.name">
                  {{ $t("lang.previous") }}
                </div>
                <div class="url" @click="getOther('previous')">
                  {{ previous.name }}
                </div>
              </div>
              <div class="right">
                <div class="text" v-if="next.name">{{ $t("lang.next") }}</div>
                <div class="url" @click="getOther('next')">{{ next.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import MarkdownIt from "markdown-it-vue";
import "markdown-it-vue/dist/markdown-it-vue.css";
import axios from "axios";
import subMenu from "../components/SubMenu.vue";
import { getLang } from "../common/utils";
export default {
  components: {
    MarkdownIt,
    subMenu,
  },
  data() {
    return {
      search: "",
      fileName: "",
      options: {
        markdownIt: {
          html: true,
          // 去除超链接显示
          //linkify: true,
          typographer: true,
        },
        linkAttributes: {
          attrs: {
            //target: "_blank",
            rel: "noopener",
          },
        },
        githubToc: {
          tocFirstLevel: 2,
          tocLastLevel: 3,
          tocClassName: "toc",
          anchorLinkSymbol: "",
          anchorLinkSpace: false,
          anchorClassName: "anchor",
          anchorLinkSymbolClassName: "octicon octicon-link",
        },
        image: {
          hAlign: "left",
          viewer: false,
        },
      },
      menuData: [],
      content: "",
      activeIndex: "",
      breadcrumbData: [],
      previous: {},
      next: {},
      fileData: [],
    };
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      const lang = getLang();
      let json = "./zh-CN/fileMenu-interface.json";
      if (lang === "en-US") {
        json = "./en-US/fileMenu-interface.json";
      } else {
        json = "./zh-CN/fileMenu-interface.json";
      }
      axios.get(json).then((response) => {
        this.menuData = response.data.file;
        this.getFileData(this.menuData);
        console.log("menuData",this.menuData)
        let data = {};
        if(this.$route.params.filename !== response.data.defaultName) {
          for(let i=0; i<this.menuData.length; i++){
            if(this.menuData[i].children){
              for(let j=0; j<this.menuData[i].children.length; j++){
                if(this.menuData[i].children[j].name == this.$route.params.filename){
                  this.activeIndex = this.menuData[i].children[j].type;
                  data.url = this.menuData[i].children[j].url
                  data.name = this.menuData[i].children[j].name;
                  data.type = this.menuData[i].children[j].type;
                  this.getFile(data);
                  return;
                }
              }
            }else if (this.menuData[i].url){
              if(this.menuData[i].name == this.$route.params.filename){
                this.activeIndex = this.menuData[i].type;
                data.url = this.menuData[i].url
                data.name = this.menuData[i].name;
                data.type = this.menuData[i].type;
                this.getFile(data);
                return;
              }
            }
          }
        }else {
          this.activeIndex = response.data.defaultType;
          data.url = response.data.defaultUrl;
          data.name = response.data.defaultName;
          data.type = response.data.defaultType;
          this.getFile(data);
        }
        
      });
    },
    getFileData(menuData) {
      menuData.forEach((ele) => {
        if (ele.children) {
          this.getFileData(ele.children);
        } else {
          this.fileData.push(ele);
        }
      });
    },
    getFile(data) {
      let url = data.url;
      this.$router.push({ path: `/DOC/${data.name}`})
      this.fileName = data.name;
      axios.get(url).then((response) => {
        this.content = response.data;
        document.getElementById("imain").scrollTop = 0;
      });
      let bodyBottomDivider = document.getElementById('markdown-body-bottom-divider');
      let bodyBottomGuide = document.getElementById('markdown-body-bottom-guide');
      if(data.type == "3-0") {
        bodyBottomDivider.style.display = "none";
        bodyBottomGuide.style.display = "none";
        return
      } else {
        bodyBottomDivider.style.display = "block";
        bodyBottomGuide.style.display = "block";
        //获取面包屑
        let type = data.type;
        this.breadcrumbData = [];
        let typeData = type.split("-");
        this.getBreadcrumb(this.menuData, typeData, 1);

        //上一篇、下一篇
        for (let i = 0; i < this.fileData.length; i++) {
          const element = this.fileData[i];
          if (element.type === type) {
            this.next =
              i === this.fileData.length - 1 ? {} : this.fileData[i + 1];
            this.previous = i === 0 ? {} : this.fileData[i - 1];
          }
        }
      }
      
    },
    getBreadcrumb(data, typeData, depth) {
      let type = "";
      for (let i = 0; i < depth; i++) {
        if (i === depth - 1) {
          type += typeData[i];
        } else {
          type += typeData[i] + "-";
        }
      }
      data.forEach((ele) => {
        if (ele.type === type) {
          this.breadcrumbData.push(ele.name);
          if (ele.children) {
            this.getBreadcrumb(ele.children, typeData, ++depth);
          }
        }
      });
    },
    getOther(flag) {
      let data = flag === "next" ? this.next : this.previous;
      this.activeIndex = data.type;
      this.getFile(data);
    },
  },
};
</script>

<style lang="less">
.interface {
  width: 100%;
  // height: calc(100vh - 65px);
  text-align: left;
  background-color: #f0f5f8;


  .el-container {
    // margin: 0 13.5%;
    background-color: #f0f5f8;

    .el-aside {
      //border-right: 1px solid #e6e6e6;
      // margin-left: 13.5%;
      background: #fafafa;
      width: 260px !important;
      font-size: 13px !important;
      .title {
        line-height: 60px;
        height: 40px;
        padding-left: 100px;
        font-size: 18px;
        //font-weight: bold;
      }

      .search {
        padding: 0 20px;

        .el-input__inner {
          border-radius: 20px;
          height: 32px;
          line-height: 32px;

          &:focus {
            border-color: rgb(50, 50, 159);
          }
        }

        .el-input__icon {
          line-height: 32px;
        }
      }

      .divider {
        padding: 0 20px;
      }
      .menu {
        overflow: auto;
        height: calc(100vh - 270px);
        .el-menu-item-group__title {
          display: none;
        }
        .el-menu {
          border-right: none;
          background-color: #fafafa;
          .el-menu-item {
            font-size: 14px;
          }
          .el-submenu__title {
            font-size: 14px;
          }
          .el-submenu__title:hover {
            background-color: rgba(0, 0, 0, 0.05);
          }

          .el-menu-item:focus,
          .el-menu-item:hover {
            background-color: rgba(0, 0, 0, 0.05);
          }

          .el-menu-item.is-active {
            color: white;
            background-color: #597EF7 ;
          }
        }
      }
    }

    .el-main {

      padding: 0;
      height: 100%;
      background-color: #fff;
      //background-color: #F8F8F8 !important;

      .main {
        background-color: #fff;
        padding: 20px;
        padding-right: 234px;
        padding-left: 48px;
        position: relative;

        .hljs {
          color: #a9b7c6;
          background: #282b2e;
          display: block;
          overflow-x: auto;
          padding: 0.5em;
        }

        .hljs-comment,
        .hljs-quote {
          color: #808080;
        }

        .hljs-keyword,
        .hljs-selector-tag,
        .hljs-deletion,
        .hljs-built_in {
          color: #cc7832;
        }

        .hljs-number,
        .hljs-literal,
        .hljs-symbol,
        .hljs-bullet {
          color: #6897bb;
        }

        .hljs-bullet,
        .hljs-link,
        .hljs-meta,
        .hljs-selector-id,
        .hljs-symbol,
        .hljs-title {
          color: #ffc66d;
        }

        .hljs-string,
        .hljs-attribute,
        .hljs-addition {
          color: #6a8759;
        }

        .markdown-body pre > code {
          white-space: pre-wrap;
        }

        .markdown-body h1,
        .markdown-body h2 {
          border: none;
        }

        .markdown-body h1 {
          font-size: 0;
        }

        .breadcrumb {
          font-size: 14px;

          .el-breadcrumb__inner {
            color: rgba(0, 0, 0, 0.45);
          }

          .el-breadcrumb__item:last-child {
            color: rgba(0, 0, 0, 0.45);
          }
        }

        .filename {
          font-size: 28px;
          //font-weight: bold;
          margin: 20px 0;
        }

        .updateTime {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
          margin-bottom: 20px;
        }

        .divider {
          height: 1px;
          width: 100%;
          background-color: #e8e8e8;
        }

        ul.toc {
          position: fixed;
          right: 1%;
          top: 160px;
          bottom: 0;
          width: 200px;
          overflow: auto;
          font-size: 12px;
          list-style-type: none;
          padding-left: 14px;
          padding-right: 10px;
          border-left: 1px solid #DFE2E5;
          line-height: 24px;
          li {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            a {
              color: rgba(0, 0, 0, 0.65);
              &:hover {
                color: #597EF7 ;
                text-decoration: none;
              }
            }
          }
        }

        .guide {
          font-size: 14px;
          padding-bottom: 50px;

          .left {
            float: left;
          }

          .right {
            float: right;
            text-align: right;
          }

          .text {
            color: rgba(0, 0, 0, 0.45);
          }

          .url {
            color: rgba(0, 0, 0, 0.85);
            cursor: pointer;

            &:hover {
              color: #597EF7;
            }
          }
        }
      }
    }
  }
}
</style>
